import { isNil } from 'lodash-es';
import { OneServiceMeta } from 'types/services/services';
import triggerNotification from 'utils/event/triggerNotification';

/**
 * Handle a success from an API call by triggering notification.
 * @param _data data from API call
 * @param meta meta data from the API
 */
const onApiSuccess = (_data: unknown, meta: OneServiceMeta | undefined) => {
  const successNotification = meta?.notifications?.success;

  if (!isNil(successNotification)) {
    triggerNotification({ id: successNotification.id });
  }
};

export default onApiSuccess;
